/**
 * Last known nav-chip values (balance, level, streak) per child, so a page load draws the chips at their real size
 * straight away instead of popping them in when the state request returns, which reflowed the whole nav bar. Only a
 * display hint: the server's state replaces it moments later, and awards are never computed from it. localStorage,
 * per child (siblings share a device).
 */
const key = (childId) => `sparksNav:${childId}`;

const storageOf = (storage) => storage || (typeof localStorage !== 'undefined' ? localStorage : null);

const FIELDS = ['enabled', 'balance', 'level', 'levelThresholds', 'dailyStreak', 'streakFreezes'];

/** The cached chip values with `navReady: true`, or {} when there are none. */
export function readNavCache(childId, storage) {
  if (!childId) return {};
  try {
    const raw = storageOf(storage)?.getItem(key(childId));
    const cached = raw ? JSON.parse(raw) : null;
    if (!cached || typeof cached !== 'object') return {};
    const out = { navReady: true };
    for (const f of FIELDS) if (f in cached) out[f] = cached[f];
    return out;
  } catch (e) {
    return {};
  }
}

export function writeNavCache(childId, state, storage) {
  if (!childId) return;
  try {
    const out = {};
    for (const f of FIELDS) out[f] = state[f];
    storageOf(storage)?.setItem(key(childId), JSON.stringify(out));
  } catch (e) {
    // Private mode / blocked storage: the chips just appear when the state arrives.
  }
}
